<page-title text="Digital Currency Prices | BitOasis" i18n-text="@@pageTitle.pricesPage"></page-title>
<page-meta
    description="Explore digital assets on BitOasis. Check prices, charts and descriptions of Bitcoin, Ethereum and more."
    i18n-description="@@pageMeta.description.pricesPage">
</page-meta>
<site-layout>
  <section class="prices-wrap">
    <div class="container">
      <!-- Compact header -->
      <div class="prices-header">
        <span class="prices-badge" i18n="@@front.prices.tag">LIVE PRICES</span>
        <h1 class="prices-title" i18n="@@front.prices.title">
          Today's <span class="text-neon">Market</span>
        </h1>
        <p class="prices-sub" i18n="@@front.prices.subtitle">
          Real-time cryptocurrency market data across all assets on BitOasis
        </p>
      </div>

      <!-- Prices component -->
      <crypto-prices [search]="search"></crypto-prices>
    </div>
  </section>
</site-layout>
<site-footer></site-footer>